<div class="place-holding"></div>

<div class="service-term-page">
  <section class="service-term-hero">
    <div class="service-term-hero__badge">{{ 'ServiceTerm.badge' | translate }}</div>
    <h1 class="service-term-title">{{ 'ServiceTerm.title' | translate }}</h1>
    <p class="service-term-hero__desc">{{ 'ServiceTerm.description' | translate }}</p>
    <div class="service-term-hero__meta">
      <span>{{ 'ServiceTerm.meta.lastUpdated' | translate }}</span>
      <span>{{ 'ServiceTerm.meta.effective' | translate }}</span>
    </div>
  </section>

  <div class="service-term-layout">
    <aside class="service-term-aside">
      <div class="service-term-toc">
        <p class="service-term-toc__title">{{ 'ServiceTerm.tocTitle' | translate }}</p>
        <button type="button" (click)="scrollToSection('service-term-section-1')">{{ 'ServiceTerm.section1.title' | translate }}</button>
        <button type="button" (click)="scrollToSection('service-term-section-2')">{{ 'ServiceTerm.section2.title' | translate }}</button>
        <button type="button" (click)="scrollToSection('service-term-section-3')">{{ 'ServiceTerm.section3.title' | translate }}</button>
        <button type="button" (click)="scrollToSection('service-term-section-4')">{{ 'ServiceTerm.section4.title' | translate }}</button>
        <button type="button" (click)="scrollToSection('service-term-section-5')">{{ 'ServiceTerm.section5.title' | translate }}</button>
        <button type="button" (click)="scrollToSection('service-term-section-6')">{{ 'ServiceTerm.section6.title' | translate }}</button>
        <button type="button" (click)="scrollToSection('service-term-section-7')">{{ 'ServiceTerm.section7.title' | translate }}</button>
        <button type="button" (click)="scrollToSection('service-term-section-8')">{{ 'ServiceTerm.section8.title' | translate }}</button>
      </div>
    </aside>

    <div class="service-term-main">
      <section class="service-term-section" id="service-term-section-1">
        <div class="service-term-section__index">01</div>
        <div class="service-term-section__body">
          <h2>{{ 'ServiceTerm.section1.title' | translate }}</h2>
          <p>{{ 'ServiceTerm.section1.content' | translate }}</p>
        </div>
      </section>

      <section class="service-term-section" id="service-term-section-2">
        <div class="service-term-section__index">02</div>
        <div class="service-term-section__body">
          <h2>{{ 'ServiceTerm.section2.title' | translate }}</h2>
          <ul>
            <li *ngFor="let item of ('ServiceTerm.section2.list' | translate)">{{ item }}</li>
          </ul>
        </div>
      </section>

      <section class="service-term-section" id="service-term-section-3">
        <div class="service-term-section__index">03</div>
        <div class="service-term-section__body">
          <h2>{{ 'ServiceTerm.section3.title' | translate }}</h2>
          <p>{{ 'ServiceTerm.section3.content' | translate }}</p>
        </div>
      </section>

      <section class="service-term-section" id="service-term-section-4">
        <div class="service-term-section__index">04</div>
        <div class="service-term-section__body">
          <h2>{{ 'ServiceTerm.section4.title' | translate }}</h2>
          <ul>
            <li *ngFor="let item of ('ServiceTerm.section4.list' | translate)">{{ item }}</li>
          </ul>
        </div>
      </section>

      <section class="service-term-section" id="service-term-section-5">
        <div class="service-term-section__index">05</div>
        <div class="service-term-section__body">
          <h2>{{ 'ServiceTerm.section5.title' | translate }}</h2>
          <p>{{ 'ServiceTerm.section5.content' | translate }}</p>
        </div>
      </section>

      <section class="service-term-section" id="service-term-section-6">
        <div class="service-term-section__index">06</div>
        <div class="service-term-section__body">
          <h2>{{ 'ServiceTerm.section6.title' | translate }}</h2>
          <p>{{ 'ServiceTerm.section6.content' | translate }}</p>
        </div>
      </section>

      <section class="service-term-section" id="service-term-section-7">
        <div class="service-term-section__index">07</div>
        <div class="service-term-section__body">
          <h2>{{ 'ServiceTerm.section7.title' | translate }}</h2>
          <p>{{ 'ServiceTerm.section7.content' | translate }}</p>
        </div>
      </section>

      <section class="service-term-section service-term-section--contact" id="service-term-section-8">
        <div class="service-term-section__index">08</div>
        <div class="service-term-section__body">
          <h2>{{ 'ServiceTerm.section8.title' | translate }}</h2>
          <p class="service-term-section__lead">{{ 'ServiceTerm.section8.content' | translate }}</p>
          <div class="contact-card">
            <p>{{ 'ServiceTerm.section8.company' | translate }}</p>
            <p>{{ 'ServiceTerm.section8.address' | translate }}</p>
            <p>{{ 'ServiceTerm.section8.email' | translate }}</p>
            <p>{{ 'ServiceTerm.section8.phone' | translate }}</p>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
